/* — Hide fixed hero video *and* heading once it scrolls out of view — */
document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector(
    '[data-section-type="video-section"].video-section--fixed-bg'
  );
  if (!hero) return;

  const vid     = hero.querySelector('.video-section__media > *');
  const overlay = hero.querySelector('.video-heading-overlay');
  if (!vid || !overlay) return;

  vid.style.transition      = 'opacity ';
  overlay.style.transition  = 'opacity';

  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const visible = entry.isIntersecting;
      vid.style.opacity      = visible ? '1' : '0';
      overlay.style.opacity  = visible ? '1' : '0';

      hero.classList.toggle('is-out', !visible);   // for the CSS rule above
    });
  }, { threshold: 0 });

  io.observe(hero);
});
